import { render, staticRenderFns } from "./shuxingDialog.vue?vue&type=template&id=853ed346&scoped=true"
import script from "./shuxingDialog.vue?vue&type=script&lang=js"
export * from "./shuxingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853ed346",
  null
  
)

export default component.exports